<template>
  <div>
    <label>Body</label>

    <div class="mb-2 editor-toolbar">
      <button type="button" class="btn btn-default btn-sm" @click="run('bold')" :class="{ active: isActive('bold') }"><strong>B</strong></button>
      <button type="button" class="btn btn-default btn-sm" @click="run('italic')" :class="{ active: isActive('italic') }"><em>I</em></button>
      <button type="button" class="btn btn-default btn-sm" @click="run('underline')" :class="{ active: isActive('underline') }"><u>U</u></button>
      <button type="button" class="btn btn-default btn-sm" @click="run('bullet_list')" :class="{ active: isActive('bullet_list') }">List</button>
      <button type="button" class="btn btn-default btn-sm" @click="run('ordered_list')" :class="{ active: isActive('ordered_list') }">1.</button>
      <button type="button" class="btn btn-default btn-sm" @click="run('hard_break')">Line Break</button>

      <select
        ref="mergeFieldSelect"
        class="form-control input-sm field-insert-select"
        aria-label="Insert merge field"
        @change="insertFieldFromSelect"
      >
        <option value="">Insert merge field…</option>
        <option v-for="field in mergeFields" :key="field" :value="field">
          {{ '{' + field + '}' }}
        </option>
      </select>
    </div>

    <editor-content class="email-template-editor" :editor="editor" />
    <input type="hidden" name="email_template[body]" :value="htmlBody">
  </div>
</template>

<script>
import { Editor, EditorContent } from 'tiptap'
import { insertText } from 'tiptap-commands'
import {
  Bold,
  BulletList,
  HardBreak,
  History,
  Italic,
  ListItem,
  OrderedList,
  Underline
} from 'tiptap-extensions'

export default {
  name: 'EmailTemplateBodyEditor',
  components: {
    EditorContent
  },
  props: {
    initialBody: {
      type: String,
      default: ''
    },
    mergeFields: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      editor: null,
      htmlBody: this.initialBody
    }
  },
  mounted () {
    this.editor = new Editor({
      content: this.initialBody,
      extensions: [
        new Bold(),
        new Italic(),
        new Underline(),
        new BulletList(),
        new OrderedList(),
        new ListItem(),
        new HardBreak(),
        new History()
      ],
      onUpdate: ({ getHTML }) => {
        this.htmlBody = getHTML()
      }
    })
  },
  beforeDestroy () {
    if (this.editor) this.editor.destroy()
  },
  methods: {
    run (commandName) {
      if (!this.editor) return
      const cmd = this.editor.commands[commandName]
      if (typeof cmd === 'function') cmd()
      this.editor.focus()
    },
    isActive (name) {
      if (!this.editor || !this.editor.isActive[name]) return false
      return this.editor.isActive[name]()
    },
    insertFieldFromSelect (event) {
      const field = event.target.value
      if (!field || !this.editor) return

      const { view } = this.editor
      insertText(`{${field}}`)(view.state, view.dispatch, view)
      view.focus()

      event.target.value = ''
    }
  }
}
</script>

<style scoped>
.email-template-editor {
  border: 1px solid #ccc;
  border-radius: 4px;
  min-height: 320px;
  padding: 12px;
  background: #fff;
}

.email-template-editor ::v-deep .ProseMirror {
  min-height: 280px;
  outline: none;
}

.editor-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.field-insert-select {
  flex: 1 1 200px;
  min-width: 180px;
  max-width: 280px;
}
</style>
